import { initializeApp } from 'firebase/app';
import { FIREBASE_CONFIG } from '../constants/firebase.constants';

export const firebaseInit = () => {
  return initializeApp(FIREBASE_CONFIG);
};
